module.exports = __webpack_public_path__ + "img/3262517.png";